import { SxProps, mergeSx, tokens } from '@cast/design-system';

export const navTriggerGap = tokens.primitives.space['200'];

export const navBreadcrumbGap = tokens.primitives.space['200'];

export const navTriggerPaddingX = tokens.primitives.space['200'];

export const navTriggerLabelSx = {
  lineHeight: '20px',
};

const navTriggerSx: SxProps = {
  py: 0,
  minHeight: '28px',
  borderRadius: '4px',
  cursor: 'pointer',
  border: '1px solid transparent',
  '&:hover': {
    backgroundColor: tokens.theme.bg.action.ghostHover,
  },
};

/** Resets native `<button>` defaults when using `Box component="button"`. */
const navTriggerButtonResetSx: SxProps = {
  font: 'inherit',
  textAlign: 'left',
  backgroundColor: 'transparent',
  color: 'inherit',
};

const navTriggerOpenSx: SxProps = {
  borderColor: tokens.theme.border.selection.primary,
  boxShadow: `0 0 0 1px ${tokens.theme.border.selection.primary}`,
};

export const getNavTriggerButtonSx = (isOpen: boolean): SxProps =>
  mergeSx(navTriggerSx, navTriggerButtonResetSx, isOpen && navTriggerOpenSx)!;
